import { FC, ReactElement, ReactNode } from 'react';

import { SystemFieldType, VirtualFieldType } from '../../../../hooks/item-fields/types';
import { Info } from '../../Info';
import type { LocationData, SublocationData } from './Location';
import { Location, Sublocation } from './Location';

export type FieldData = {
	id: string;
	value: string | unknown | undefined;
	icon?: FC | ReactNode | undefined;
};

/**
 * Renders a field with appropriate component based on field type.
 * Handles location and sublocation fields with specialized components,
 * otherwise falls back to the standard Info component.
 *
 * @param field - The field data containing id, value, and optional icon
 * @returns React element or null if value is empty
 */
export const renderField = (field: FieldData): ReactElement | null => {
	const { id, value, icon } = field;

	if (!value) return null;

	// Handle location/sublocation fields with specialized components
	if (id === SystemFieldType.location) {
		return <Location key={id} location={value as LocationData} />;
	}

	if (id === VirtualFieldType.sublocation) {
		return <Sublocation key={id} data={value as SublocationData} />;
	}

	// Default to Info component for other fields
	return <Info key={id} icon={icon} text={value as string | ReactNode} />;
};
